import React from "react";

const Overview = ({ text }) => {
  return (
    <div className="bg-[#39699D]">
      <div className="mx-auto max-w-6xl  md:p-10 p-3 space-y-3">
        <div>
          <p className="text-white font-bold text-lg md:text-xl">
            Program Overview
          </p>
        </div>
        <div className="bg-sdbodywhite h-0.5 w-10"></div>
        <div>
          <p className="text-white text-sm md:text-base text-justify">{text}</p>
        </div>
      </div>
    </div>
  );
};

export default Overview;
